const scroll = () => {
  const trigger = $('.scroll');
  trigger.click(function() {
    const id = $(this).data('scroll');
    console.log(id);
    const element = document.getElementById(id);
    const headerOffset = 130;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  });
};

export default scroll;